import { ArcGISIdentityManager } from '@esri/arcgis-rest-request';
import {
  queryFeatures,
  getLayer,
  IQueryFeaturesResponse,
  IQueryResponse,
  ILayerDefinition,
  IFeatureServiceDefinition,
} from '@esri/arcgis-rest-feature-service';

import { ArcGISAuthError } from '@esri/arcgis-rest-request';
import { SortColumn } from 'react-data-grid';

import { timeoutPromise } from './dataUtils';

export async function featureQuery(
  start: number,
  rowsPerPage: number,
  currentUrl: string,
  whereStatement: string,
  session?: ArcGISIdentityManager,
  sort?: SortColumn[],
  signal?: AbortSignal
): Promise<FeaturePage> {
  // Set up sorting order string
  const querySortOrder =
    sort && sort.length > 0 ? `${sort[0].columnKey} ${sort[0].direction}` : '';

  // Make the request using specified parameters
  const response = (await queryFeatures({
    url: currentUrl,
    where: whereStatement,
    orderByFields: querySortOrder,
    resultOffset: start,
    resultRecordCount: rowsPerPage,
    returnGeometry: false,
    authentication: session,
    signal,
  })) as IQueryFeaturesResponse;

  // Extract features and display them
  const rows = response.features.map(
    (feature: { attributes: FeatureAttributes }) => feature.attributes
  );

  return { rows, start, end: start + rowsPerPage };
}

export async function getLayerTotalRows(
  url: string,
  session?: ArcGISIdentityManager,
  where = '1=1'
): Promise<number> {
  const response = (await timeoutPromise(
    5000,
    new Error("Couldn't get layer total rows"),
    queryFeatures({
      url,
      returnIdsOnly: true,
      authentication: session,
      where,
    })
  )) as IQueryResponse;
  return response.objectIds ? response.objectIds.length : 0;
}

export async function checkIfTokenRequired(
  url: string,
  session?: ArcGISIdentityManager
): Promise<boolean> {
  try {
    // Attempt to access layer
    const response = (await getLayer({
      url,
      authentication: session,
    })) as ILayerDefinition | IFeatureServiceDefinition;

    if ('layers' in response) {
      throw new Error('Feature Service not supported');
    }

    // If no error is thrown, url is good and does not require token
    return false;
  } catch (error) {
    // Only return true if auth error, otherwise throw the error
    if (error instanceof ArcGISAuthError) return true;
    throw error;
  }
}
